import { h, Fragment } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";

export default function QuickBuySize({ variant, index }) {
  const size = variant.selectedOptions[0].value;

  if (!size) return;

  const handleClick = () => {
    if (!variant.availableForSale) return;

    const data = {
      id: gidToId(variant.id),
      quantity: 1,
    };

    window.addToCart(data, {
      onAfterAdd: () => {
        document.dispatchEvent(new CustomEvent("mini-cart:open"));
      },
    });
  };

  return (
    <button
      className={`utility-2 quick-buy__button quick-buy__button--size ${
        !variant.availableForSale ? "quick-buy__button--disabled" : ""
      }`}
      aria-label={`${
        variant.availableForSale
          ? `Add size ${size} to cart`
          : `Size ${size} is sold out`
      }`}
      onClick={handleClick}
      style={{ "--index": index }}
    >
      {size}
    </button>
  );
}
